import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { renderToStaticMarkup } from "react-dom/server";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import {
  darcula,
  vscDarkPlus,
} from "react-syntax-highlighter/dist/esm/styles/prism";
import { AiFillHome } from "react-icons/ai";
import { PreviewSvgIcon, CodeSvgIcon, SlabSvgIcon } from "./svg";
import pretty from "pretty";
import "./tooltip.css";
const PreviewCodeSection = ({
  Component,
  rawString_VUE,
  rawString_React,
  rawString_HTML,
}) => {
  const location = useLocation();
  const [selectBtn, setSelectBtn] = useState("preview");
  const [selectLang, setSelectLang] = useState("react");

  const handleSelectBtn = (val) => {
    if (val) {
      setSelectBtn(val);
    }
  };

  const handleSelectLang = (e, option) => {
    console.log("handleSelectLang => val", e?.target.value);
    setSelectLang(e?.target.value);
  };

  const getCode = () => {
    if (selectLang === "react") {
      return rawString_React;
    } else if (selectLang === "vue") {
      return rawString_VUE;
    } else if (selectLang === "html") {
      return rawString_HTML;
    } else {
      return "Invalid Language select";
    }
  };
  const getSectionFromRoute = () => {
    const pathSegments = location.pathname.split("/");
    return pathSegments[pathSegments.length - 1];
  };
  const copyToClipboard = () => {
    const codeToCopy = getCode();
    navigator.clipboard.writeText(codeToCopy).then(
      function () {
        console.log("Code copied to clipboard successfully!");
        // You can add a visual indication or a toast message here
      },
      function (err) {
        console.error("Unable to copy code to clipboard", err);
      }
    );
  };
  const section = getSectionFromRoute();

  let heading = "";
  switch (section) {
    case "signup":
      heading = "Signup Components";
      break;
    case "signin":
      heading = "Login Components";
      break;
    case "comment":
      heading = "Comment Components";
      break;
    case "posts":
      heading = "Create post";
      break;
    case "image-Gallery":
      heading = "Gallery Components";
      break;
    case "users":
      heading = "User Indicator Components";
      break;
    case "forms":
      heading = "Forms Components";
      break;
    case "toast":
      heading = "Toasts";
      break;
    case "fly-button":
      heading = "Fly Buttons";
      break;
    case "Questionaire":
      heading = "Questionaire";
      break;
    case "cards":
      heading = "Cards";
      break;
    case "add-address":
      heading = "Address Components";
      break;
    case "carts":
      heading = "Carts";
      break;
    case "footer":
      heading = "Footers";
      break;
    case "nav":
      heading = "Navbars";
      break;
    case "toast":
      heading = "Toasts";
      break;
    case "my-profile":
      heading = "My Profiles";
      break;
    case "side-banner":
      heading = "Side Banners ";
      break;
    case "hero-banner":
      heading = "Heros Banners ";
      break;
    case "servicedetail":
      heading = "Service Details";
      break;
    case "full-screen-loader":
      heading = "Screen Loaders";
      break;
    case "category-slider":
      heading = "Category Slider ";
      break;
    default:
      heading = "Sections";
  }

  return (
    <div className="relative  border  mx-auto mt-20 w-full max-w-container px-4 sm:px-6 lg:px-8">
      <div class="flex flex-col">
        <h1 className="mt-3 text-3xl font-extrabold tracking-tight text-slate-900">
          {heading}
        </h1>
        <nav
          aria-label="Breadcrumbs"
          className="order-first flex space-x-2 text-sm font-semibold mt-3"
        >
          <a href="/" className="flex mr-2">
            <AiFillHome className="mt-1 text-2xl text-indigo-500 hover:text-indigo-700" />
            <span className="mt-1 text-lg ml-2 text-indigo-500 hover:text-indigo-700">
              Home
            </span>
          </a>
        </nav>
      </div>
      <div>
        <section id="component-b9bcab4538776a17fff93d18f82a8272">
          <div class="grid grid-cols-[1fr,auto] items-center">
            <div class="flex min-w-0">
              <h2 class="truncate text-base font-medium leading-7 text-slate-900">
                <a href="#component-b9bcab4538776a17fff93d18f82a8272">
                  Simple centered
                </a>
              </h2>
              <p class="ml-3 hidden whitespace-nowrap rounded-lg bg-slate-100 px-2 py-0.5 text-xs font-semibold leading-6 text-slate-700 lg:block">
                Requires JS
              </p>
            </div>
            <div class="ml-6  flex items-center">
              <div
                class="flex space-x-1 rounded-lg bg-slate-100 p-0.5 border shadow-md"
                role="tablist"
                aria-orientation="horizontal"
              >
                <button
                  class={`flex items-center rounded-md py-[0.4375rem]  transition ease-in-out delay-300 pl-2 pr-2 text-sm font-semibold lg:pr-3 ${
                    selectBtn === "preview" ? `bg-white` : ""
                  }  shadow`}
                  id="headlessui-tabs-tab-21"
                  role="tab"
                  type="button"
                  aria-selected="true"
                  tabindex="0"
                  onClick={() => handleSelectBtn("preview")}
                  data-headlessui-state="selected"
                  aria-controls="headlessui-tabs-panel-23"
                >
                  <PreviewSvgIcon />
                  <span class="sr-only lg:not-sr-only lg:ml-2 text-slate-900">
                    Preview
                  </span>
                </button>
                <button
                  class={`flex items-center rounded-md py-[0.4375rem] transition ease-in-out delay-300  pl-2 pr-2 text-sm font-semibold lg:pr-3 ${
                    selectBtn === "code" ? `bg-white` : ""
                  }  shadow`}
                  id="headlessui-tabs-tab-22"
                  role="tab"
                  type="button"
                  onClick={() => handleSelectBtn("code")}
                  aria-selected="false"
                  tabindex="-1"
                  data-headlessui-state=""
                  aria-controls="headlessui-tabs-panel-24"
                >
                  <CodeSvgIcon />
                  <span class="sr-only lg:not-sr-only lg:ml-2 text-slate-600">
                    Code
                  </span>
                </button>
              </div>
              <div class="ml-6 mr-3 hidden h-5 w-px bg-slate-900/10 sm:block"></div>
              <div class="relative hidden sm:block">
                <select
                  onChange={(val, option) => handleSelectLang(val, option)}
                >
                  <option value="react">React</option>
                  <option value="html">HTML</option>
                  <option value="vue">Vue</option>
                </select>
              </div>
              <span className="tooltip" onClick={() => copyToClipboard()}>
                <SlabSvgIcon />
                <span className="tooltiptext">Copy Code</span>
              </span>
            </div>
            <div class="col-span-2 row-start-2  min-w-0 relative overflow-hidden rounded-3xl mt-8 mb-8 w-11/12 ml-16 shadow-md">
              {selectBtn === "preview" ? (
                <>
                  <Component />
                </>
              ) : (
                <SyntaxHighlighter language="jsx" style={vscDarkPlus}>
                  {getCode()}
                </SyntaxHighlighter>
              )}
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default PreviewCodeSection;
